import axios from 'axios';
import { GET_START_HIGHWAY_LINE_API_URL, GET_END_HIGHWAY_LINE_API_URL, GET_CABLE_CONNECTION_API_URL,
    GET_PILLAR_CONNECTION_API_URL, GET_WELL_CONNECTION_API_URL, GET_COUPLING_CONNECTION_API_URL,
    GET_FOB_CONNECTION_API_URL, GET_HOUSE_CONNECTION_API_URL, GET_PON_BOX_CONNECTION_API_URL} from '../OpticApiConfig';
import { CABLE, COUPLING, FOB, HOUSE, PILLAR, PON_BOX, WELL } from '../Constants/ConstantsOptics';

export const DescriptionComponents = async (selectedComponent, inputId, showSnackbar, setFlagVisiblePillar, setFlagVisibleWell, setFlagVisibleCoupling,
    setFlagVisibleFob, setDataStartCable, setDataEndCable, setDataConnectionCable, setFlagVisibleCable, setDataConnectionPillar,
    setDataConnectionWell, setDataConnectionCoupling, setDataConnectionFob, setDataConnectionHouse, setFlagVisibleHouse,
    setFlagVisiblePonBox, setDataConnectionPonBox) => {

    if(selectedComponent === '' || inputId === '') {
      showSnackbar('Пустой ID или тип компонента!!!', 'snackbarWarning');
    } else {
      const token = localStorage.getItem('token');
     
      if(selectedComponent == CABLE){
        setFlagVisiblePillar(false)
        setFlagVisibleWell(false);
        setFlagVisibleCoupling(false);
        setFlagVisibleFob(false);
        setFlagVisiblePonBox(false);
        setFlagVisibleHouse(false);

        try {
          let apiUrlStartCable =`${GET_START_HIGHWAY_LINE_API_URL}?id=${inputId}`;
          const resultStartCable = await axios.get(apiUrlStartCable, {
            headers:{
              'Authorization': `Bearer ${token}` 
            }
          });
          setDataStartCable(resultStartCable.data);

          let apiUrlEndCable =`${GET_END_HIGHWAY_LINE_API_URL}?id=${inputId}`;
          const resulEndCable = await axios.get(apiUrlEndCable, {
            headers:{
              'Authorization': `Bearer ${token}` 
            }
          });
          setDataEndCable(resulEndCable.data); 


          let apiUrlConnectionCable =`${GET_CABLE_CONNECTION_API_URL}?id=${inputId}`;
          const resulConnection = await axios.get(apiUrlConnectionCable, {
            headers:{
              'Authorization': `Bearer ${token}` 
            }
          });
          setDataConnectionCable(resulConnection.data); 

          
          setFlagVisibleCable(true);
        
        } catch (error) {
          console.error("Ошибка при отправке запроса");
        }
      }else if(selectedComponent == PILLAR){
        setFlagVisibleCable(false)
        setFlagVisibleWell(false);
        setFlagVisibleCoupling(false);
        setFlagVisibleFob(false);
        setFlagVisiblePonBox(false);
        setFlagVisibleHouse(false);

        try {
          let apiUrlConnectionPillar =`${GET_PILLAR_CONNECTION_API_URL}?id=${inputId}`;
          const resulConnection = await axios.get(apiUrlConnectionPillar, {
            headers:{
              'Authorization': `Bearer ${token}` 
            }
          });
          setDataConnectionPillar(resulConnection.data);
          
          setFlagVisiblePillar(true);
        
        } catch (error) {
          console.error("Ошибка при отправке запроса");
        }
      }else if(selectedComponent == WELL){
        setFlagVisibleCable(false)
        setFlagVisiblePillar(false);
        setFlagVisibleCoupling(false);
        setFlagVisibleFob(false);
        setFlagVisibleHouse(false);
        setFlagVisiblePonBox(false);

        try {
          let apiUrlConnectionWell =`${GET_WELL_CONNECTION_API_URL}?id=${inputId}`;
          const resulConnection = await axios.get(apiUrlConnectionWell, {
            headers:{
              'Authorization': `Bearer ${token}` 
            }
          });
          setDataConnectionWell(resulConnection.data);
          
          setFlagVisibleWell(true);
        
        } catch (error) {
          console.error("Ошибка при отправке запроса");
        }
      }else if(selectedComponent == COUPLING){
        setFlagVisibleCable(false)
        setFlagVisiblePillar(false);
        setFlagVisibleWell(false);
        setFlagVisibleFob(false);
        setFlagVisibleHouse(false);
        setFlagVisiblePonBox(false);

        try {
          let apiUrlConnectionCoupling =`${GET_COUPLING_CONNECTION_API_URL}?id=${inputId}`;
          const resulConnection = await axios.get(apiUrlConnectionCoupling, {
            headers:{
              'Authorization': `Bearer ${token}` 
            }
          });
          setDataConnectionCoupling(resulConnection.data);
          
          setFlagVisibleCoupling(true);
        
        } catch (error) {
          console.error("Ошибка при отправке запроса");
        }
      }else if(selectedComponent == FOB){
        setFlagVisibleCable(false)
        setFlagVisiblePillar(false);
        setFlagVisibleWell(false);
        setFlagVisibleCoupling(false);
        setFlagVisibleHouse(false);
        setFlagVisiblePonBox(false);

        try {
          let apiUrlConnectionFob =`${GET_FOB_CONNECTION_API_URL}?id=${inputId}`;
          const resulConnection = await axios.get(apiUrlConnectionFob, {
            headers:{
              'Authorization': `Bearer ${token}` 
            }
          });
          setDataConnectionFob(resulConnection.data);
          setFlagVisibleFob(true);
        
        } catch (error) {
          console.error("Ошибка при отправке запроса");
        }
      }else if(selectedComponent == PON_BOX){
        setFlagVisibleCable(false)
        setFlagVisiblePillar(false);
        setFlagVisibleWell(false);
        setFlagVisibleCoupling(false);
        setFlagVisibleHouse(false);
        setFlagVisibleFob(false);

        try {
          let apiUrlConnectionPonBox =`${GET_PON_BOX_CONNECTION_API_URL}?id=${inputId}`;
          const resulConnection = await axios.get(apiUrlConnectionPonBox, {
            headers:{
              'Authorization': `Bearer ${token}` 
            }
          });
          setDataConnectionPonBox(resulConnection.data);
          setFlagVisiblePonBox(true);
        
        } catch (error) {
          console.error("Ошибка при отправке запроса");
        }
      }else if(selectedComponent == HOUSE){
        setFlagVisibleCable(false)
        setFlagVisiblePillar(false);
        setFlagVisibleWell(false);
        setFlagVisibleCoupling(false);
        setFlagVisibleFob(false);
        setFlagVisiblePonBox(false);

        try {
          let apiUrlConnectionHouse =`${GET_HOUSE_CONNECTION_API_URL}?id=${inputId}`;
          const resulConnection = await axios.get(apiUrlConnectionHouse, {
            headers:{
              'Authorization': `Bearer ${token}` 
            }
          });
         
          setDataConnectionHouse(resulConnection.data);
          
          setFlagVisibleHouse(true);
        
        } catch (error) {
          console.error("Ошибка при отправке запроса");
        }
      }else{
        console.log("Пока удаляю только с таблици Well");
      }    
    }
  }
